<template>
  <div class="step-card">
    <div class="ios-group-header">步骤 1 · 校验卡密</div>

    <div class="ios-card card-main">
      <div class="card-icon-row">
        <div class="card-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="5" width="20" height="14" rx="3"></rect>
            <line x1="2" y1="10" x2="22" y2="10"></line>
          </svg>
        </div>
        <div>
          <div class="card-title">输入卡密</div>
          <div class="card-desc">请输入您购买的兑换卡密</div>
        </div>
      </div>

      <div class="input-group">
        <label class="ios-field-label" for="cardCode">卡密编号</label>
        <input
          id="cardCode"
          v-model="inputCardCode"
          type="text"
          placeholder="例如：CARD-123456"
          class="ios-input"
          :class="{ 'has-error': error }"
          @keyup.enter="validateCard"
        />
        <div v-if="error" class="ios-error-text">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ error }}</span>
        </div>
      </div>

      <button
        @click="validateCard"
        class="btn-filled"
        :disabled="!inputCardCode.trim() || loading"
      >
        <span v-if="loading" class="ios-spinner"></span>
        {{ loading ? '验证中…' : '校验卡密' }}
      </button>
    </div>

    <template v-if="cardInfo">
      <div class="ios-group-header">卡密信息</div>
      <div class="ios-card ios-list card-info">
        <div class="ios-row">
          <span class="ios-row-label">商品名称</span>
          <span class="ios-row-value">{{ cardInfo.productName }}</span>
        </div>
        <div class="ios-row">
          <span class="ios-row-label">商品别名</span>
          <span class="ios-row-value">{{ cardInfo.productAlias }}</span>
        </div>
        <div class="ios-row">
          <span class="ios-row-label">卡密状态</span>
          <span class="ios-row-value" :class="getStatusClass(cardInfo.cardStatus)">{{ cardInfo.cardStatusText }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { validateCard } from '../services/api'

export default {
  name: 'StepCard',
  props: {
    cardCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputCardCode: this.cardCode,
      cardInfo: null,
      error: '',
      loading: false
    }
  },
  watch: {
    cardCode(val) {
      this.inputCardCode = val
    }
  },
  methods: {
    async validateCard() {
      this.loading = true
      this.error = ''
      this.cardInfo = null

      const response = await validateCard(this.inputCardCode)

      if (response.code === 200) {
        this.cardInfo = response.data
        this.$emit('validated', { cardCode: this.inputCardCode, cardInfo: response.data })
      } else {
        this.error = response.message || '卡密校验失败'
      }

      this.loading = false
    },
    getStatusClass(status) {
      switch (status) {
        case 1: return 'status-available'
        case 2: return 'status-used'
        default: return 'status-unavailable'
      }
    }
  }
}
</script>

<style scoped>
.card-main {
  padding: 26px 22px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.card-icon-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 11px;
  background: rgba(0, 122, 255, 0.1);
  color: var(--ios-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-icon svg {
  width: 22px;
  height: 22px;
}

.card-title {
  font-size: 19px;
  font-weight: 600;
}

.card-desc {
  margin-top: 2px;
  font-size: 14px;
  color: var(--ios-label-secondary);
}

.input-group {
  display: flex;
  flex-direction: column;
}

.card-info {
  animation: fadeIn 0.35s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .card-main {
    padding: 16px 14px;
  }
}
</style>
